import { type FC } from 'react'
import { type FormikHelpers } from 'formik'
import { useTranslation } from 'react-i18next'

import { type Servicepoint } from '@dhl/receiver-servicepoint'

import { useSetTitle, useWizardContext } from '~/setup/model/context.js'
import { StepForm } from '../StepForm.js'
import { useSubmitPreference } from '~/profile/view/preferences/hooks/useSubmitPreference.js'
import { ServicepointDetails } from '~/profile/view/preferences/setup/components/ServicepointDetails.js'
import { steps } from '~/setup/model/steps.js'
import { useGetProfileLastAddedAddress } from '~/profile/model/profile/hooks.js'

type ServicePointStepValues = {
  addressId: string
  servicepoint: Servicepoint
}

export const DeliveryPreferenceServicePointSelect: FC = () => {
  const { t } = useTranslation()
  const { getStepSubmittedValues, onStepComplete } = useWizardContext()
  const { data: lastAddedAddress } = useGetProfileLastAddedAddress()

  const stepValues = getStepSubmittedValues<ServicePointStepValues>(steps.deliveryPreferenceServicePointList)

  const { submitPreference } = useSubmitPreference()

  useSetTitle(t('portal.profile.preferences.options.ServicePointDelivery.title'))

  const handleSubmit = async (_: unknown, helpers: FormikHelpers<unknown>) => {
    if (!lastAddedAddress?.addressId || !stepValues?.servicepoint?.servicepointKey) {
      helpers.setSubmitting(false)
      return
    }

    try {
      await submitPreference(lastAddedAddress?.addressId, {
        preferenceType: 'ServicePointDelivery',
        psfKey: stepValues?.servicepoint?.servicepointKey,
      })

      onStepComplete()
    } catch {
      helpers.setSubmitting(false)
    }
  }

  const initialValues = {}

  return (
    <StepForm enableReinitialize validateOnChange initialValues={initialValues} onSubmit={handleSubmit}>
      {stepValues?.servicepoint && <ServicepointDetails servicepoint={stepValues.servicepoint} />}
    </StepForm>
  )
}
